<div *ngIf="wsLoading" class="cust-select workstreams">
    <mat-form-field class="custom-mat-sel">
        <mat-select #select (openedChange)="openedChange($event)" placeholder="{{placeholder}}" [formControl]="wsFormControl" [(ngModel)]="dbSelectedWs" multiple disableOptionCentering>
            <div class="select-container" *ngIf="wsLoadingSelect">
                <mat-optgroup >
                    <mat-form-field style="width:100%;">
                        <input #search autocomplete="off" placeholder="{{searchPlaceholder}}" matInput [formControl]="wsSearchTextboxControl"
                            class="workstreams-search-input" />
                        <button *ngIf="search.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch($event)">
                        <mat-icon class="make-close">close</mat-icon>
                        </button>
                    </mat-form-field>
                </mat-optgroup>
                <mat-optgroup *ngIf="(wsFilteredOptions | async).length == 0" class="no-result">
                    <div>No results found!</div>
                </mat-optgroup>
                <div *ngIf="selectClose" class="ngdialog-close" (click)="select.close()">Close</div>
                <div *ngIf="(wsFilteredOptions | async).length > 0" class="select-all">
                    <mat-checkbox [(ngModel)]="allSelected"
                                    [ngModelOptions]="{standalone: true}"
                                    (change)="toggleAllSelection()">Select All</mat-checkbox>
                </div>
                <mat-option (onSelectionChange)="selectionChange($event)" (click)="optionClick()" *ngFor="let option of wsFilteredOptions | async" [value]="option" [disabled]="disableSelection(option)">
                {{option}}
                </mat-option>
            </div>
        </mat-select>
    </mat-form-field>
</div>
<div *ngIf="wsLoadingSelect">
    <div *ngIf="wsFormControl.value != ''" class="selected-items ws-selected-items ps" [perfectScrollbar]="sconfig">
        <div *ngFor="let item of workstreamItems; let t=index" class="tag-text ws-tag-text">
            <span>{{item}}</span>
            <i class="material-icons tag-close" (click)="disableTagSelection(t)">close</i>
        </div>
    </div>
</div>